import { StationCardTypes } from './StationCard/types';
import { StationDetailCardTypes } from './StationDetailCard/types';
import { SessionType } from './UserSessionCard/types';
import { TransactionType } from './UserTransactionCard/types';

export enum CardEnum {
  Station_card = 'Station_card',
  Direction_to_station_card = 'Direction_to_station_card',
  User_Session_card = 'User_Session_card',
  User_transaction_card = 'User_transaction_card',
}

export interface CardProps {
  type: CardEnum;
  data:
    | StationCardTypes
    | StationDetailCardTypes
    | SessionType
    | TransactionType;
}
